<template>
    <input 
    	type="text"
        ref="birth"
        data-format="YYYY-MM-DD"
        data-template="D MMMM YYYY"
        :data-max-year="maxYear"
        :error-class="errorClass">	
</template>

<script>
    import moment from 'moment'

	export default {
        model: {
            prop: 'date',
            event: 'update'
        },
		props: {
            date: String,
            errorClass: String,
            maxYear: {
                type: Number,
                default: parseInt(moment().format('Y'))
            }
        },
        watch: {
            date(val) {
                let element = this.$refs.birth
                $(element).combodate({
                    value: val
                }); 
            }
        },
        mounted() {
            this.initComboDate()
        },
        methods: {
            initComboDate() {
                let element = this.$refs.birth
                $(element).combodate(); 

                $(element).on('change', (e) => {
                    this.$emit('update', e.target.value)
                })                         
            }
        }
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/PartecipantBirthdayInput.vue